import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <footer className="relative z-10 border-t border-museo-border mt-32 py-12 px-6 md:px-12">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-8">
        <Link to="/" data-testid="footer-home-link" className="font-serif text-xl text-museo-text hover:text-museo-accent transition-colors duration-500">
          Il Museo delle Promesse
        </Link>
        <nav className="flex flex-wrap items-center justify-center gap-x-8 gap-y-3 text-sm tracking-wide text-museo-muted">
          <Link to="/privacy" data-testid="footer-privacy-link" className="hover:text-museo-accent transition-colors">Privacy Policy</Link>
          <Link to="/termini" data-testid="footer-termini-link" className="hover:text-museo-accent transition-colors">Termini e Condizioni</Link>
          <Link to="/contatti" data-testid="footer-contatti-link" className="hover:text-museo-accent transition-colors">Contatti</Link>
          <Link to="/segnala" data-testid="footer-segnala-link" className="hover:text-museo-accent transition-colors">Segnala una promessa</Link>
        </nav>
        <p className="text-xs text-museo-muted/60 text-center max-w-md font-light">
          Un'opera digitale collettiva. Le promesse sono anonime e permanenti.
        </p>
      </div>
    </footer>
  );
};
